import { render, staticRenderFns } from "./ActualizarMontoBolsa.vue?vue&type=template&id=2ad22016"
import script from "./ActualizarMontoBolsa.vue?vue&type=script&lang=js"
export * from "./ActualizarMontoBolsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports